module.exports = __webpack_public_path__ + "static/media/howitwork3.d17d4a74.jpg";